import { STATUS_GRAY, STATUS_GREEN } from '../Overview/statusColors'
import { InvoiceStatus } from '../types'

export const invoiceStatusColor = (status: InvoiceStatus): string =>
  status === 'pending' ? STATUS_GRAY : STATUS_GREEN

export const invoiceStatusLabelKey = (status: InvoiceStatus): string => {
  if (status === 'sent') return 'financial.invoices.statusSent'
  if (status === 'available') return 'financial.invoices.statusAvailable'
  return 'financial.invoices.statusPending'
}
